// This is only for StructureLPlus
export const PADDING_STRUCTURE = 32
export const MIN_WIDTH = 416
const BUTTON_WITH_REM = 3
const REM_TO_PX = 16
export const CLOSE_BUTTON_WIDTH = BUTTON_WITH_REM * REM_TO_PX
